import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page39() {
  useEffect(() => {
    document.title = "Маяк — Страница 38"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page37" />
        <ForwardLink href="/page39" />
      </div>

      <p style={{ textAlign: "right" }}>38.</p>
      <p>МОЛОДОЙ застывает.</p>
      <p>
        Затем ЧАЙКА опускает клюв в цистерну... хватает<br/>
        чайку клювом и начинает пожирать ее.
      </p>
      <p>МОЛОДОЙ пытается вмешаться...</p>
      <p>ОДНОГЛАЗАЯ ЧАЙКА <u>АТАКУЕТ</u> ЛИЦО МОЛОДОГО!</p>
      <p>МОЛОДОЙ РВЕТ ЕЕ В ДИКОЙ ЯРОСТИ...</p>
      <p>
        ОДНИМ БЫСТРЫМ ДВИЖЕНИЕМ ОН ХВАТАЕТ ЧАЙКУ ЗА НОГИ И УДАРЯЕТ<br/>
        ЕЕ О КРАЙ ЦИСТЕРНЫ...
      </p>
      <p>СНОВА И СНОВА, И СНОВА, И СНОВА, И СНОВА...</p>
      <p>И СНОВА...</p>
      <p>ДО ТЕХ ПОР, ПОКА ОНА НЕ СТАНЕТ ОКРОВАВЛЕННЫМИ ПЕРЬЯМИ...</p>
      <p><u>ОДНОГЛАЗАЯ ЧАЙКА МЕРТВА</u>.</p>
      <p>МОЛОДОЙ тяжело дышит. Виновато.</p>
      <p>Задержка.</p>
      <p>Ветер дует мягко.</p>
      <p>
        Он скручивает сигарету, трясется. Он робко смотрит вверх,<br/>
        на башню, чтобы проверить наблюдает ли за ним СТАРИК.
      </p>
      <p>
        КАМЕРА ПОДНИМАЕТСЯ ВВЕРХ К БАШНЕ МАЯКА, мимо подиума (смотровой площадки), мимо<br/>
        фонаря, мимо конической крыши к...
      </p>
      <p>ФЛЮГЕР: СТРЕЛКА УКАЗЫВАЕТ НА <u>ЗАПАД</u>...</p>
      <p>
        Вдруг порывы ветра... СТРЕЛКА начинает слегка<br/>
        покачиваться...
      </p>
      <p>
        Ветер усиливается... СТРЕЛКА вращается, и вращается, и<br/>
        вращается...
      </p>
      <p>
        Она останавливается. Слегка покачиваясь на ветру, СТРЕЛКА УКАЗЫВАЕТ<br/>
        ПРЯМО НА: <u>ВОСТОК</u>.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – ПОЗЖЕ</p>
      <p>
        МОЛОДОЙ стоит в дверях, вытирая<br/>
        лицо носовым платком.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Цистерна была открыта, сэр и...
      </p>
      <p style={{ textAlign: "right" }}>38.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page37" />
        <ForwardLink href="/page39" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710021522/the-lighthouse-script/s5uev0vvallw3ugxlhzg.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page39;
